import { LegacyObjectListRequestType } from '../ObjectListResponseTypes'
import { ObjectListType } from '../ObjectListTypes'

export enum InvoiceStatus {
  PAID = 'Paid',
  OPEN = 'Open',
}

export type InvoiceSource = 'snappy' | 'odoo'
export interface InvoiceList extends ObjectListType {
  invoices: Invoice[]
  // Union type to perfectly bridge the old string array and the new structured meta block
  meta: string[]
}
export interface Invoice {
  id: number
  invoiceNr: string
  name: string
  date: string
  duedate: string
  type: string
  totalIncVat: number
  totalExcVat: number
  openIncVat: number
  openExcvat: number
  status: string
  statusId: string
  cdrAvailable: boolean
  source: InvoiceSource
}
export interface InvoiceRequest extends LegacyObjectListRequestType {}

export const isInvoiceListType = (invoicelist: any): invoicelist is InvoiceList => {
  if (invoicelist === undefined) {
    return false
  }
  return 'invoices' in invoicelist
}

export const isInvoice = (invoice: any): invoice is Array<Invoice> => {
  if (invoice === undefined) {
    return false
  }
  if (Array.isArray(invoice)) {
    return 'invoiceNr' in invoice[0]
  }
  return 'invoiceNr' in invoice
}

export const isInvoiceRequest = (request: any): request is InvoiceRequest => {
  if (request === undefined) {
    return false
  }
  return true
  //return 'statusid' in request
}
